import React, { useEffect, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import ScreenContainer from "../../Components/ScreenContainer";
import Events from "../../Analytics/Events";
import DataDownloadMain from "../../PagesContent/DataDownload/DataDownloadMain";
import { getPagesMetaData } from "../../Api/Api";
import CODE from "../../Static/Constants/StatusCodes";

const DataDownload = () => {
  const [pagesContent, setPagesContent] = useState({ mounted: false });

  useEffect(() => {
    Events("Data Download page opened");
    loadPageMeta();
  }, []);

  const loadPageMeta = async () => {
    try {
      const res = await getPagesMetaData("dataDownload");
      if (res?.responseStatus?.code === CODE.SUCCESS) {
        const pageData = res.response?.response;
        setPagesContent({
          ...pageData?.metaInfo,
          metaInfo: pageData?.metaInfo,
          mounted: true,
        });
      } else {
        setPagesContent({ mounted: true });
      }
    } catch {
      setPagesContent({ mounted: true });
    }
  };

  return (
    <ScreenContainer pagesContent={pagesContent}>
      <Box sx={{ px: 3, pt: 3, pb: 2 }}>
        <Typography variant="fw500s20c000000" sx={{ fontSize: "24px", lineHeight: "24px" }}>
          Data Download
        </Typography>
      </Box>
      <Divider orientation="horizontal" flexItem sx={{ borderColor: "#E4E4E4" }} />
      <DataDownloadMain />
    </ScreenContainer>
  );
};

export default DataDownload;
